// extracted by mini-css-extract-plugin
export default {"dialog-title":"ieYJe_dialog-title","dialog-button":"e5m9C_dialog-button","dialog-button-right":"JVUMO_dialog-button-right"};